import script from "./adminManage.vue?vue&type=script&setup=true&lang=js"
export * from "./adminManage.vue?vue&type=script&setup=true&lang=js"

import "./adminManage.vue?vue&type=style&index=0&id=1f300973&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f300973"]])

export default __exports__